import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { APP_NAME } from '@shared/constants';
import { CONFIG_TOKEN } from '@shared/tokens';

@Injectable({ providedIn: 'root' })
export class TitleService extends TitleStrategy {
  readonly #title = inject(Title);
  readonly #translateService = inject(TranslateService);
  readonly #config = inject(CONFIG_TOKEN);

  public updateTitle(snapshot: RouterStateSnapshot): void {
    const titleTranslationKey = this.buildTitle(snapshot);
    this.setTitle(titleTranslationKey);
  }

  public addListener(listener$: Observable<string | undefined>, translate = true): void {
    listener$.subscribe({
      next: (val) => {
        this.setTitle(val, translate);
      },
      error: () => {
        this.setDefaultTitle();
      },
      complete: () => {
        this.setDefaultTitle();
      },
    });
  }

  private setTitle(titleOrTranslationKey?: string, translate = true): void {
    if (!titleOrTranslationKey) return;

    const title = translate ? this.#translateService.instant(titleOrTranslationKey) : titleOrTranslationKey;
    this.#title.setTitle(`${this.buildTitleWithTag()} - ${this.#translateService.instant(title)}`);
  }

  private setDefaultTitle(): void {
    this.#title.setTitle(this.buildTitleWithTag());
  }

  private buildTitleWithTag(): string {
    return this.#config.titleTag ? `[${this.#config.titleTag}] ${APP_NAME}` : `${APP_NAME}`;
  }
}
